import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./ContactoBanner.css"; // Archivo de estilos

const ContactoBanner = () => {
  const navigate = useNavigate();

  return (
    <section className="contacto-banner">
      <div className="contacto-overlay">
        <Container className="text-center">
          <h1>¿Tenés dudas o necesitás asesoramiento?</h1>
          <h2>Contáctanos y te guiaremos en tu elección.</h2>
          <Button
            variant="light"
            className="contacto-btn"
            onClick={() => navigate("/contacto")}
          >
            Hablá con nosotros
          </Button>
        </Container>
      </div>
    </section>
  );
};

export default ContactoBanner;
